import React from 'react';
import { connect } from 'react-redux';
import { getDateMDYY, getPocText, getStatusIndicator, getIconStatusIndicator, getRTMStatusIndicator } from '_helpers';
import styles from './Header.module.css';
import { DBDateField, DBTextArea, StatusCritical, StatusWarning } from '_components';
import { PatientCareCenterNoteHeaderNoteType } from './NoteType';

class PatientCareCenterNoteHeader extends React.Component {

    getPlanYearsOutput(warn, prevent) {
        if (prevent) {
            return (
                <div className={styles.auth_wrapper}>
                    <span className={styles.indicator}><StatusCritical size='extra-small' /></span>
                    <span className={styles.planyears_title}>Plan Years:</span>
                    <span className={styles.long}>This patient has a visit per calendar year max and you are attempting to schedule past the cap.   Please  discharge or discuss transition to self-pay.</span>
                </div>
            );
        }
        else if (warn) {
            return (
                <div className={styles.auth_wrapper}>
                    <span className={styles.indicator}><StatusWarning size='extra-small' /></span>
                    <span className={styles.planyears_title}>Plan Years:</span>
                    <span className={styles.long}>This patient has a visit per calendar year max.  They have 3 or less visits remaining after this appointment.  You will not be allowed to schedule past their cap.  The patient may switch to self-pay to continue after their final visit.</span>
                </div>
            );
        }
    }

    render() {
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        });

        return (
            <div>
                <PatientCareCenterNoteHeaderNoteType />

                {Object.keys(this.props.auths)
                    .filter(key => this.props.auths[key].status > 1)
                    .map(id => {
                        const auth = this.props.auths[id];
                        if (auth.status === 4) {
                            return (
                                <div className={styles.auth_wrapper} key={auth.position}>
                                    <span className={styles.indicator}>{getStatusIndicator(auth.status)}</span>
                                    <span className={styles.title}>AUTH:</span>
                                    <span className={styles.col1} title={auth.payerName}>{auth.payerName}</span>
                                    <span className={styles.long}>No Current Auth</span>
                                </div>
                            )
                        } else if (auth.status === 5) {
                            return (<div key="-1"></div>)
                        }
                        else {
                            return (
                                <div className={styles.auth_wrapper} key={auth.position}>
                                    <span className={styles.indicator}>{getStatusIndicator(auth.status)}</span>
                                    <span className={styles.title}>AUTH:</span>
                                    <span className={styles.col1} title={auth.payerName}>{auth.payerName}</span>
                                    <span className={styles.col2}>{getDateMDYY(auth.startDate) + ' - ' + getDateMDYY(auth.endDate)}</span>
                                    <span className={styles.col3}>{auth.visits + ' visits (' + auth.visitsRemaining + ' visits remaining)'}</span>
                                </div>
                            )
                        }
                    })
                }

                {this.props.rtmAvailable &&
                    <>
                        <div className={styles.auth_wrapper}>
                            <span className={styles.indicator}>{getRTMStatusIndicator(this.props.rtmStatus)}</span>
                            <span className={styles.col3}>
                                <b>{this.props.rtmMessage.split(':')[0]}</b>
                                {this.props.rtmMessage.includes(':') ? `:${this.props.rtmMessage.split(':').slice(1).join(':')}` : ''}
                            </span>
                        </div>

                        <div className={styles.auth_wrapper}>
                            <span className={styles.indicator}>{getIconStatusIndicator(this.props.rtmIntStatus)}</span>
                            <span className={styles.col3}><b>{this.props.rtmIntMessage}</b></span>
                        </div>
                    </>
                }

                {this.props.poc &&
                    <div className={styles.auth_wrapper}>
                        <span className={styles.indicator}>{getStatusIndicator(this.props.poc.status)}</span>
                        <span className={styles.title}>POC:</span>
                        <span className={styles.col1} />
                        <span className={styles.col2}>{getDateMDYY(this.props.poc.startDate) + ' - ' + getDateMDYY(this.props.poc.endDate)}</span>
                        <span className={styles.col3}>{getPocText(this.props.poc)}</span>
                    </div>
                }

                {this.props.progDue &&
                    <div className={styles.auth_wrapper}>
                        <span className={styles.indicator}>{getStatusIndicator(3)}</span>
                        <span className={styles.title}>Progress Due:</span>
                        <span className={styles.long}>{this.props.progDue}</span>
                    </div>
                }

                {this.props.foto &&
                    <div className={styles.auth_wrapper}>
                        <span className={styles.indicator}>{getStatusIndicator(this.props.foto.status)}</span>
                        <span className={styles.title}>FOTO:</span>
                        <span className={styles.col1} />
                        <span className={styles.col2}>{getDateMDYY(this.props.foto.date)}</span>
                        <span className={styles.col3}>{this.props.foto.visitsSinceSurvey + ' visits since survey'}</span>
                    </div>
                }

                {this.props.objDate && !this.props.isPeds && !this.props.isPedsSpeech &&
                    <div className={styles.auth_wrapper}>
                        <span className={styles.indicator}>{getStatusIndicator(3)}</span>
                        <span className={styles.title}>Objective:</span>
                        <span className={styles.long}>{'has not been updated since ' + getDateMDYY(this.props.objDate)}</span>
                    </div>
                }

                {this.props.goalDate &&
                    <div className={styles.auth_wrapper}>
                        <span className={styles.indicator}>{getStatusIndicator(3)}</span>
                        <span className={styles.title}>Goals:</span>
                        <span className={styles.long}>{'have not been updated since ' + getDateMDYY(this.props.goalDate)}</span>
                    </div>
                }

                {this.props.capWarn && this.props.capWarn === 2 &&
                    <div className={styles.auth_wrapper}>
                        <span className={styles.indicator}>{getStatusIndicator(this.props.capWarn)}</span>
                        <span className={styles.title}>MC CAP:</span>
                        <span className={styles.long}>{'Patient is nearing the Medicare Cap (' + formatter.format(this.props.capUsed) + ' of ' + formatter.format(this.props.cap) + ' Used)'}</span>
                    </div>
                }

                {this.props.capWarn && this.props.capWarn === 3 &&
                    <div className={styles.auth_wrapper}>
                        <span className={styles.indicator}>{getStatusIndicator(this.props.capWarn)}</span>
                        <span className={styles.title}>MC CAP:</span>
                        <span className={styles.long}>{'Patient has met the Medicare Cap (' + formatter.format(this.props.capUsed) + ' of ' + formatter.format(this.props.cap) + ' Used)'}</span>
                    </div>
                }

                {this.props.medReview &&
                    <div className={styles.auth_wrapper}>
                        <span className={styles.indicator}>{getStatusIndicator(this.props.medReview)}</span>
                        <span className={styles.title}>Medical Review:</span>
                        <span className={styles.long}>{'Patient has met the ' + formatter.format(this.props.medReviewThreshold) + ' cap threshold and is now at risk for Medical Review (' + formatter.format(this.props.capUsed) + ' of ' + formatter.format(this.props.cap) + ' Used)'}</span>
                    </div>
                }
                {!this.props.aiConsent && !this.props.aiDecline &&
                    <div className={styles.auth_wrapper}>
                        <span className={styles.indicator}>{getStatusIndicator(2)}</span>
                        <span className={styles.title}>AI Scribe:</span>
                        <span className={styles.long}>No consent collected</span>
                    </div>
                }
                {this.props.aiDecline &&
                    <div className={styles.auth_wrapper}>
                        <span className={styles.indicator}>{getStatusIndicator(3)}</span>
                        <span className={styles.title}>AI Scribe:</span>
                        <span className={styles.long}>did not consent</span>
                    </div>
                }
                {(this.props.planYearsWarn || this.props.planYearsPrevent) &&
                    <>
                        {this.getPlanYearsOutput(this.props.planYearsWarn, this.props.planYearsPrevent)}
                    </>
                }


                {this.props.missedVisits &&
                    <>
                        <div className={styles.auth_wrapper}>
                            <span className={styles.indicator} />
                            <span className={styles.required_txt}>Date:</span>
                            <DBDateField
                                noteId={this.props.noteId}
                                entity='PTNOTE'
                                entityKeyColumn='NTNO'
                                entityKeyValue={this.props.ntno}
                                field='NTMEASUREMENTDATE'
                            />
                        </div>
                        <br />
                        <div className={styles.auth_wrapper}>
                            <span className={styles.indicator} />
                            <span className={styles.required_txtArea}>Description:</span>
                            <DBTextArea
                                noteId={this.props.noteId}
                                entity='PTNOTE'
                                entityKeyColumn='NTNO'
                                entityKeyValue={this.props.ntno}
                                field='NTMISSEDVISITDESC'
                                placeholder='Description'
                                className={styles.textarea}
                            />
                        </div>
                    </>
                }



            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let today = new Date();
    let rtmEnabled = state.entities.admissions[epno].rtmEnabled;
    let rtmActive = state.entities.admissions[epno].rtmActive;
    let rtmCom = state.entities.admissions[epno].rtmCommunication;
    let rtmMinutes = state.entities.admissions[epno].rtmMinutes;
    let rtmStatus = 4;
    let rtmMessage = 'ERROR';
    let rtmIntStatus = 4;
    let rtmIntMessage = 'Error';
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_PEDS_ENABLED'].PRVALUE === 'true' : false;
    let isPeds = state.entities.admissions[epno].isPeds && isPedsEnabled;
    let isPedsSpeech = state.entities.admissions[epno].isPeds && isPedsEnabled;

    let aiConsent = state.entities.admissions[epno].aiConsent;
    let aiDecline = state.entities.admissions[epno].aiDecline;

    let limberActive = state.entities.admissions[epno].limberActive; // location on limber; patient been sent to limber
    let hasLimberApp = state.entities.admissions[epno].hasLimberApp; // patient has app
    let rtmActiveDateSet = state.entities.admissions[epno].rtmActiveDateSet; // rtm active date set on admission

    let rtmAvailable = state.entities.admissions[epno].rtm98975Billable ||
        state.entities.admissions[epno].rtm98977Billable ||
        state.entities.admissions[epno].rtm98980Billable ||
        state.entities.admissions[epno].rtm98981Billable ||
        state.entities.admissions[epno].rtm98985Billable ||
        state.entities.admissions[epno].rtm98979Billable;


    if (rtmAvailable) {
        if (limberActive) { // new Limber
            if (!rtmActiveDateSet) { //remove && !hasLimberApp?
                rtmStatus = 3;
                rtmMessage = 'RTM eligible, RTM HEP Not Assigned';
            } else if (rtmActiveDateSet && !hasLimberApp) {
                rtmStatus = 2;
                rtmMessage = 'RTM HEP assigned, No App Downloaded';
            } else if (rtmActiveDateSet && hasLimberApp) {
                rtmStatus = 1
                rtmMessage = 'RTM HEP and App downloaded';
            }
        } else { // old Medbridge
            if (!rtmEnabled && !rtmActive) {
                rtmStatus = 3;
                rtmMessage = 'RTM:  not enabled and not activated ';
            } else if (rtmEnabled && !rtmActive) {
                rtmStatus = 2;
                rtmMessage = 'RTM:  enabled but not activated';
            } else if (rtmEnabled && rtmActive) {
                rtmStatus = 1
                rtmMessage = 'RTM:  enabled and activated';
            }
        }

        if (rtmMinutes === undefined) {
            rtmMinutes = 0;
        }

        if (!rtmCom) {
            rtmIntMessage = 'No live interaction with ' + rtmMinutes + '/20 RTM minutes this month';
            rtmIntStatus = 3;
        } else {

            const rtmInterval = Math.ceil(rtmMinutes / 20) * 20 || 20;
            rtmIntMessage = limberActive
                ? 'Live interaction with ' + rtmMinutes + '/' + rtmInterval + ' RTM minutes this month'
                : 'Live interaction with ' + rtmMinutes + '/' + rtmInterval + ' RTM minutes this month';
            rtmIntStatus = 1;
        }
    }


    today.setHours(0, 0, 0, 0);

    let auths = Object.keys(state.entities.insured)
        .filter(key => state.entities.insured[key].epno === epno)
        .sort((a, b) => state.entities.insured[a].position - state.entities.insured[b].position)
        .map(key => {

            let authKey = Object.keys(state.entities.auths)
                .find(key2 => state.entities.auths[key2].epno === epno &&
                    state.entities.auths[key2].pyno === state.entities.insured[key].pyno &&
                    new Date(state.entities.auths[key2].startDate).getTime() <= today.getTime() &&
                    new Date(state.entities.auths[key2].endDate).getTime() >= today.getTime())

            if (authKey !== undefined) {
                return {
                    position: state.entities.insured[key].position,
                    pyno: state.entities.insured[key].pyno,
                    payerName: state.entities.insured[key].payerName,
                    startDate: state.entities.auths[authKey].startDate,
                    endDate: state.entities.auths[authKey].endDate,
                    visits: state.entities.auths[authKey].visits,
                    visitsRemaining: state.entities.auths[authKey].visitsRemaining,
                    daysRemaining: state.entities.auths[authKey].daysRemaining,
                    status: state.entities.auths[authKey].status
                }
            } else {
                return {
                    position: state.entities.insured[key].position,
                    pyno: state.entities.insured[key].pyno,
                    payerName: state.entities.insured[key].payerName,
                    startDate: undefined,
                    endDate: undefined,
                    visits: undefined,
                    visitsRemaining: undefined,
                    daysRemaining: undefined,
                    status: state.entities.insured[key].AuthReq ? 4 : 5 // 5 = No Auth Required, 4 = No Current Auth
                }
            }
        });

    auths = Object.keys(auths)
        .filter(key => auths[key].status > 1)
        .map(key => auths[key]);

    let pocKey = Object.keys(state.entities.pocs)
        .find(key => state.entities.pocs[key].epno === epno &&
            new Date(state.entities.pocs[key].startDate).getTime() <= today.getTime() &&
            new Date(state.entities.pocs[key].endDate).getTime() >= today.getTime());

    let poc = undefined;


    if (pocKey !== undefined) {
        poc = state.entities.pocs[pocKey];
    } else {
        let pocs = Object.keys(state.entities.pocs)
            .filter(key => state.entities.pocs[key].epno === epno &&
                new Date(state.entities.pocs[key].endDate).getTime() < today.getTime())
            .sort((b, a) => new Date(state.entities.pocs[a].endDate).getTime() - new Date(state.entities.pocs[b].endDate).getTime())
            .map(key => state.entities.pocs[key]);
        if (pocs.length > 0) {
            poc = pocs[0];
        }
    }






    let fotos = Object.keys(state.entities.fotoSurveys)
        .filter(key => state.entities.fotoSurveys[key].epno === epno)
        .sort((a, b) => new Date(state.entities.fotoSurveys[a].date).getTime() - new Date(state.entities.fotoSurveys[b].date).getTime())
        .map(key => state.entities.fotoSurveys[key]);
    let foto = fotos.length > 0 && fotos[0].status > 1 ? fotos[0] : undefined;

    let objThreshold = state.entities.masterData.PTMASTERTHRESHOLDS[
        Object.keys(state.entities.masterData.PTMASTERTHRESHOLDS)
            .find(key => state.entities.masterData.PTMASTERTHRESHOLDS[key].WTNAME === 'OBJECTIVE_UPDATE_DAYS')].WTCRITICAL;
    let goalsThreshold = state.entities.masterData.PTMASTERTHRESHOLDS[
        Object.keys(state.entities.masterData.PTMASTERTHRESHOLDS)
            .find(key => state.entities.masterData.PTMASTERTHRESHOLDS[key].WTNAME === 'GOALS_UPDATE_DAYS')].WTCRITICAL;

    let noteUpdatesKey = Object.keys(state.entities.notes.PTNOTEUPDATES)
        .find(key => state.entities.notes.PTNOTEUPDATES[key].NoteId === noteId)

    let objDate = undefined;
    let goalDate = undefined;
    let progDue = undefined;
    if (noteUpdatesKey !== undefined) {
        objDate = state.entities.notes.PTNOTEUPDATES[noteUpdatesKey].LastObjectiveUpdate
        if (objDate && ((today.getTime() - new Date(objDate).getTime()) < (objThreshold * 24 * 60 * 60 * 1000))) {
            objDate = undefined;
        }
        goalDate = state.entities.notes.PTNOTEUPDATES[noteUpdatesKey].LastGoalsUpdate
        if (goalDate && ((today.getTime() - new Date(goalDate).getTime()) < (goalsThreshold * 24 * 60 * 60 * 1000))) {
            goalDate = undefined;
        }

        progDue = state.entities.notes.PTNOTEUPDATES[noteUpdatesKey].ProgressDue ?? undefined;
    }

    let capWarn = undefined;
    let medReview = undefined;
    let cap = state.entities.admissions[epno].mcCap;
    let capUsed = state.entities.admissions[epno].mcCapUsed;
    let medReviewThreshold = state.entities.masterData.PTMASTERTHRESHOLDS[
        Object.keys(state.entities.masterData.PTMASTERTHRESHOLDS)
            .find(key => state.entities.masterData.PTMASTERTHRESHOLDS[key].WTNAME === 'MEDICAL_REVIEW')].WTCRITICAL;

    if (state.entities.admissions[epno].isFederal) {
        let mcThresholds = state.entities.masterData.PTMASTERTHRESHOLDS[
            Object.keys(state.entities.masterData.PTMASTERTHRESHOLDS)
                .find(key => state.entities.masterData.PTMASTERTHRESHOLDS[key].WTNAME === 'MEDICARE_CAP')];
        if ((cap - capUsed) <= mcThresholds.WTWARNING && (cap - capUsed) > mcThresholds.WTCRITICAL) {
            capWarn = 2;
        } else if ((cap - capUsed) <= mcThresholds.WTCRITICAL) {
            capWarn = 3;
        }

        if (capUsed >= medReviewThreshold) {
            medReview = 3;
        }
    }

    if (state.entities.notes.NoteWarnings !== undefined) {
        if (state.entities.notes.NoteWarnings[noteId] !== undefined) {
            let isProgressDue = state.entities.notes.NoteWarnings[noteId].ISPROGRESSDUE === undefined ? state.entities.admissions[epno].isProgressDue : state.entities.notes.NoteWarnings[noteId].ISPROGRESSDUE;
            let isPocDue = state.entities.notes.NoteWarnings[noteId].ISPOCDUE === undefined ? state.entities.admissions[epno].isPocDue : state.entities.notes.NoteWarnings[noteId].ISPOCDUE;
            let authStatus = state.entities.notes.NoteWarnings[noteId].authStatus === undefined ? state.entities.admissions[epno].authStatus : state.entities.notes.NoteWarnings[noteId].authStatus;

            if (!isPocDue) {
                poc = undefined;
            }
            if (authStatus > 1) {

            }
            if (!isProgressDue) {
                progDue = isProgressDue;
            }
        }
    }

    let missedVisits = state.entities.admissions[epno].isPeds && noteType === 22;
    let ntno = parseInt(noteId.split("_")[1]);

    let planYearsWarn = state.entities.notes.PLANYEARS[noteId].warn;
    let planYearsPrevent = state.entities.notes.PLANYEARS[noteId].prevent;

    return {
        auths,
        poc,
        foto,
        objDate,
        goalDate,
        capWarn,
        cap,
        capUsed,
        medReview,
        medReviewThreshold,
        progDue,
        rtmStatus,
        rtmMessage,
        rtmIntStatus,
        rtmIntMessage,
        rtmAvailable,
        missedVisits,
        ntno,
        noteId,
        isPeds,
        isPedsSpeech,
        aiConsent,
        aiDecline,
        planYearsWarn,
        planYearsPrevent
    };
}

const connectedPatientCareCenterNoteHeader = connect(mapStateToProps)(PatientCareCenterNoteHeader);
export { connectedPatientCareCenterNoteHeader as PatientCareCenterNoteHeader };

